module.exports = __webpack_public_path__ + "img/20190712165218YY截图20190711014629.d5242911.png";